import * as React from 'react';
import * as S from './styles';
import { IFiltersProps, OrderByValues, FacebookRecommended } from './types';
import { SearchableDropdown } from 'components/SearchableDropdown';
import EditIcon from 'common/icons/editIcon';
import Chips from 'components/Chips';

const Filters: React.FC<IFiltersProps> = (props) => {
    const [keyWord, setKeyWord] = React.useState<string>('');
    const [showFilterSource, setShowFilterSource] = React.useState<boolean>(true);

    const labelStyle: any = {padding: '0 0 10px 10px', fontSize: '14px'}
    const inputStyle: any = {border: 'solid 1px #e7e7ec', borderRadius: '4px', height: '29px'}

    React.useEffect(() => {
        if (props.filterSource?.displayName==='FACEBOOK') setShowFilterSource(false);
        else setShowFilterSource(true);
    }, [props.filterSource, props.selectedTab]);
    
    const handleEditProviders =  (event: any) => {
        var container = document.getElementById('container');
        if (container) {
            var rect = container.getBoundingClientRect();
            var x = event.clientX + container.scrollLeft - rect.left - 581;
            var y = event.clientY + container.scrollTop - rect.top -150;
            props.handleEditProviders({show: true, posX: x , posY: y, widget: 'reviewList'})
        }
    }
    
    const handleEditRatings =  (event: any) => {
        var container = document.getElementById('editRatingsContainer');
        if (container) {
            var rect = container.getBoundingClientRect();
            var x = event.clientX + container.scrollLeft - rect.left + 60;
            var y = event.clientY + container.scrollTop - rect.top + 35;
            props.handleEditRatings({show: true, posX: x , posY: y})
        }
    }

    const handleKeyPress = (event: { key: string }) => {
        if (event.key==='Enter') {
            props.setKeyWords([...props.keyWords, keyWord]);
            setKeyWord('');
        }
    }

    const handleRemoveChip = (index: number) => {   
        props.setKeyWords(props.keyWords.filter((word: string, idx: number) => idx!==index));
    }

    const handleSelectSource = (selectedItem) => {
        setShowFilterSource(!(selectedItem.displayName && selectedItem.displayName.toUpperCase()==='FACEBOOK'));
        props.setFilterSource(selectedItem);
    }

    return (
        <S.Root>
        <S.Row style={{marginTop: '34px'}}>
            <S.Col>
            <S.Title style={{color: props.bodyColor}} >
                Filter By:
            </S.Title>
            <S.Row>
                <S.Selectcontainer>
                <SearchableDropdown
                    selectedOption={props.filterSource}
                    value={props.filterSource?.displayName??''}
                    options={props.sourceList}
                    isLoading={false}
                    canLoadMoreOptions={false}
                    emptyText={''}
                    placeholder={"Source"}
                    readonly={false}
                    onValueChange={(v) => {}}
                    onOptionSelected={(selectedItem: any) => handleSelectSource(selectedItem)}
                    onDrawerDismissed={() => {}}
                    onLoadMoreOptions={() => {}}
                    notSearchable={true}
                    labelStyle={labelStyle}
                    inputStyle={inputStyle}
                    arrowSimple
                />
                </S.Selectcontainer>
                
                {props.selectedTab === "individual" &&
                <S.EditIconContainer onClick={(e) => handleEditProviders(e)}>
                    <EditIcon />
                </S.EditIconContainer>}
                
                
                <S.Selectcontainer>
                <SearchableDropdown
                    selectedOption={props.filterRating}
                    value={props.filterRating?.displayName??''}
                    options={showFilterSource ? props.ratingsList : FacebookRecommended}
                    isLoading={false}
                    canLoadMoreOptions={false}
                    emptyText={''}
                    placeholder={showFilterSource ? "Star Rating" : "Rating"}
                    readonly={false}
                    onValueChange={(v) => {}}
                    onOptionSelected={(selectedItem: any) => props.setFilterRating(selectedItem, showFilterSource ? "rating" : "recommended")}
                    onDrawerDismissed={() => {}}
                    onLoadMoreOptions={() => {}}
                    notSearchable={true}
                    labelStyle={labelStyle}
                    inputStyle={inputStyle}
                    arrowSimple
                />
                </S.Selectcontainer>
                {
                    props.editRatingsList && 
                    <S.EditRatingsContainer id="editRatingsContainer">
                    <S.EditIconContainer onClick={(e) => handleEditRatings(e)}>
                    <EditIcon />
                    </S.EditIconContainer>
                    </S.EditRatingsContainer>
                }

                <S.Selectcontainer>
                <S.KeywordsInput
                    placeholder={`Enter keyword`}
                    value={keyWord}
                    onChange={(e)=> setKeyWord(e.target.value)}
                    onKeyPress={(e)=> handleKeyPress(e)}
                />
                </S.Selectcontainer>

            </S.Row>
            </S.Col>

            <S.Col style={{position:'absolute' ,right: '0'}}>
            <S.SortByTitle style={{color: props.bodyColor}} >
                Sort By:
            </S.SortByTitle>
            <S.Row>
                <S.Selectcontainer style={{width:'250px'}}>
                <SearchableDropdown
                    selectedOption={props.orderBy}
                    value={props.orderBy?.displayName??''}
                    options={OrderByValues}
                    isLoading={false}
                    canLoadMoreOptions={false}
                    emptyText={''}
                    placeholder={""}
                    readonly={false}
                    onValueChange={(v) => {}}
                    onOptionSelected={props.setOrderBy}
                    onDrawerDismissed={() => {}}
                    onLoadMoreOptions={() => {}}
                    notSearchable={true}
                    labelStyle={labelStyle}
                    inputStyle={inputStyle}
                    arrowSimple
                />
                </S.Selectcontainer>
            </S.Row>
            </S.Col>
        </S.Row>
        {props.keyWords?.length>0 &&
        <S.Row style={{marginTop: '42px', display: 'block'}}>
            <S.Title style={{color: props.bodyColor}} >
            Keywords:
            </S.Title>
            <S.ChipsContainer>
            <Chips
                items={props.keyWords}
                handleRemove={handleRemoveChip}
                style={{width: 'auto'}}
                chipStyle={{
                        fontFamily: 'Rubik',
                        fontSize: '14px',
                        marginTop: '0px',
                        borderRadius: '30px',
                        border: 'solid 1.5px #4da0ff',
                        backgroundColor: 'rgba(77, 160, 255, 0.05)',
                }}
                removeIconStyle={{backgroundColor: '#8a8a8a70'}}
            />
            </S.ChipsContainer>
        </S.Row>}
        </S.Root>
    )
}

export default Filters;
